import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Scan = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Scan' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M20,14 L20,21 L4,21 L4,14 L4,14 M1,12 L23,12 L1,12 Z M4,11 L4,8 L4,11 Z M20,8 L20,11 L20,8 Z M7,3 L4,3 L4,6 M20,6 L20,3 L17,3 M9,3 L15,3 L9,3 Z' transform='matrix(1 0 0 -1 0 24)' />
  </StyledIcon>
);
